import React from "react";
import themeLarge from "../ThemeLarge";
import { FaRegCalendarAlt } from "react-icons/fa";
import "../../css/FeaturedBlogView.css";

class FeaturedBlogView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: window.innerWidth <= 768,
    };
  }

  updateWindowSize = () => {
    this.setState({
      isMobile: window.innerWidth <= 768,
    });
  };

  componentDidMount() {
    this.updateWindowSize(); // initial set
    window.addEventListener("resize", this.updateWindowSize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowSize);
  }

  render() {
    const { featuredBlog, onClick } = this.props;
    const { isMobile } = this.state;
    const linearGradient = isMobile ? 100 : 60;

    if (!featuredBlog) return null;
    const createdAt = featuredBlog.createdAt
      ? (() => {
        const createdDate = new Date(featuredBlog.createdAt.seconds * 1000);
        const now = new Date();
        const diffTime = now - createdDate;
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays === 0) {
          return "Published today";
        } else if (diffDays === 1) {
          return "Published yesterday";
        } else {
          return `Published ${diffDays} days ago`;
        }
      })()
      : "Unknown Date";

    return (
      <div
        className="row mt-2 mb-4"
        style={{
          position: "relative",
          height: "300px",
          borderRadius: isMobile ? "25px" : "15px",
          overflow: "hidden",
          color: "white",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        {/* Background Image with gradient mask */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.7) ${linearGradient}%, rgba(0,0,0,0)), url(${featuredBlog.coverPhoto})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: 1,
            borderWidth: "1px",
            borderStyle: "groove",
            boxShadow: themeLarge.shadows.large,
          }}
        ></div>

        {/* Content Overlay */}
        <div
          className="col-12 d-flex flex-column justify-content-center"
          style={{
            position: "relative",
            zIndex: 2,
            color: themeLarge.colors.gradient,
            paddingLeft: isMobile ? "15px" : "48px",
          }}
        >
          <span
            className="mb-2"
            title="Featured Blog"
            style={{
              paddingLeft: "10px",
              paddingRight: "15px",
              paddingTop: "3px",
              paddingBottom: "3px",
              borderWidth: "1px",
              borderColor: themeLarge.colors.text,
              borderRadius: "15px",
              borderStyle: "groove",
              fontSize: themeLarge.fontSize.small,
              color: themeLarge.colors.text,
              background: themeLarge.colors.secondary,
              width: "fit-content",
              fontWeight: "500",
            }}
          >
            🌟 Featured
          </span>

          <p
            className="featured-title"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: this.state.isMobile ? "unset" : 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontFamily: "Noto Sans",
              fontWeight: "600",
              fontSize: this.state.isMobile
                ? themeLarge.fontSize.h4
                : themeLarge.fontSize.h1,
            }}
          >
            {featuredBlog.title}
          </p>

          <p
            className="featured-excerpt mt-1"
            style={{
              fontSize: themeLarge.fontSize.small,
              color: isMobile ? "#FBF9FF" : themeLarge.colors.gradient,
              opacity: "0.9",

            }}
          >
            {featuredBlog.excerpt}
          </p>

          <p
            className="featured-created-at mt-2"
            style={{
              fontSize: themeLarge.fontSize.small,
              color: isMobile ? "#FBF9FF" : themeLarge.colors.gradient,
              opacity: "0.85",
            }}
          >
            <FaRegCalendarAlt />
            {createdAt}
          </p>
        </div>
      </div>
    );
  }
}

export default FeaturedBlogView;
